import { getConsent } from './cookieConsent';

function postJsonReliably(url, payload) {
    const body = JSON.stringify(payload);
    if (typeof navigator.sendBeacon === 'function') {
        const queued = navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
        if (queued) return;
    }
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true
    }).catch(() => {});
}

function trackOutboundClick(dealId, source, clickRef) {
    if (!dealId) return;
    postJsonReliably(`/api/clicks/${dealId}`, {
        source,
        clickRef: clickRef || undefined,
        analyticsAllowed: Boolean(getConsent()?.analytics)
    });
}

function trackSearchEvent(payload) {
    if (!getConsent()?.analytics) return false;
    postJsonReliably('/api/search-events', { ...payload, analyticsAllowed: true });
    return true;
}

function trackActivationEvent(eventName) {
    if (!getConsent()?.analytics) return false;
    const safeName = String(eventName || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
    if (!safeName) return false;

    const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid'];
    const campaign = Object.fromEntries(campaignKeys.map((key) => [
        key,
        window.sessionStorage.getItem(`esganga_${key}`) || ''
    ]));

    postJsonReliably('/api/pageviews', {
        path: `/__events/${safeName}`,
        referrer: document.referrer || '',
        utmSource: campaign.utm_source,
        utmMedium: campaign.utm_medium,
        utmCampaign: campaign.utm_campaign,
        gclid: campaign.gclid,
        analyticsAllowed: true
    });
    return true;
}

export { postJsonReliably, trackActivationEvent, trackOutboundClick, trackSearchEvent };
